import Autism from '../../../assets/ads/Autism.png'
import Ebola from '../../../assets/ads/Ebola.png'
import Leadership from '../../../assets/ads/Leadership.png'
import Location from '../../../assets/ads/Location.png'
import COVID19 from '../../../assets/ads/COVID19.png'

const shuffleArray = data => {
  let currentIndex = data.length
  let tempVal, randIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    tempVal = data[currentIndex]
    data[currentIndex] = data[randIndex]
    data[randIndex] = tempVal
  }

  return data
}

export default {
  name: 'admenu',
  props: [],
  components: {},
  mounted() {
    this.currentAd = this.ads.pop()
    setInterval(() => {
      this.ads.unshift(this.currentAd)
      this.currentAd = this.ads.pop()
    }, 30000)
  },
  data() {
    return {
      ads: shuffleArray([Autism, Ebola, Leadership, Location, COVID19]),
      currentAd: false
    }
  }
}
